// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"59":"57f10529","80":"fd523d51","411":"68bcd2b4"}[chunkId] + ".js";
};